// Utilidades de "zumbido" NAWARA - 100% browser-side, sin assets externos.
// Funciona en iPhone Safari, Android Chrome, escritorio.

let _ctx = null;
function getCtx() {
  if (typeof window === 'undefined') return null;
  if (!_ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    _ctx = new AC();
  }
  // En iOS el contexto entra "suspended" hasta que hay un gesto del usuario.
  // El que reciba el zumbido ya tuvo gestos previos en la app, asi que normalmente
  // se reanuda OK.
  if (_ctx.state === 'suspended') {
    _ctx.resume().catch(() => {});
  }
  return _ctx;
}

function playBuzz({ duration = 0.45, freq = 220, repeats = 2, gap = 0.12 } = {}) {
  const ctx = getCtx();
  if (!ctx) return;
  const now = ctx.currentTime;
  for (let i = 0; i < repeats; i++) {
    const start = now + i * (duration + gap);
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'square';
    osc.frequency.setValueAtTime(freq, start);
    osc.frequency.linearRampToValueAtTime(freq * 0.7, start + duration);
    gain.gain.setValueAtTime(0.0001, start);
    gain.gain.exponentialRampToValueAtTime(0.35, start + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);
    osc.connect(gain).connect(ctx.destination);
    osc.start(start);
    osc.stop(start + duration + 0.02);
  }
}

function speakNawara() {
  if (typeof window === 'undefined' || !('speechSynthesis' in window)) {
    // Fallback al buzz si no hay TTS
    playBuzz({ duration: 0.35, freq: 280, repeats: 3, gap: 0.1 });
    return;
  }
  try {
    const u = new SpeechSynthesisUtterance('¡NAWARA!');
    u.lang = 'es-ES';
    u.rate = 1.05;
    u.pitch = 1.1;
    u.volume = 1.0;
    window.speechSynthesis.cancel();
    window.speechSynthesis.speak(u);
  } catch (e) {
    playBuzz({ duration: 0.35, freq: 280, repeats: 3, gap: 0.1 });
  }
}

export function vibrate(pattern) {
  try {
    if (typeof navigator !== 'undefined' && navigator.vibrate) {
      navigator.vibrate(pattern);
    }
  } catch (e) { /* ignore */ }
}

export function playTone(tone) {
  switch (tone) {
    case 'emergency':
      // Sirena oscilante repetitiva
      playSiren();
      vibrate([400, 100, 400, 100, 400, 100, 400, 100, 600]);
      break;
    case 'buzz_long':
      playBuzz({ duration: 0.7, freq: 200, repeats: 3, gap: 0.18 });
      vibrate([400, 150, 400, 150, 400]);
      break;
    case 'voice_nawara':
      speakNawara();
      vibrate([200, 100, 200]);
      break;
    case 'buzz':
    default:
      playBuzz({ duration: 0.45, freq: 220, repeats: 2, gap: 0.12 });
      vibrate([300, 120, 300]);
      break;
  }
}

function playSiren() {
  const ctx = getCtx();
  if (!ctx) return;
  const now = ctx.currentTime;
  const cycles = 3;
  const cycleDur = 0.9;
  for (let i = 0; i < cycles; i++) {
    const start = now + i * cycleDur;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sawtooth';
    osc.frequency.setValueAtTime(700, start);
    osc.frequency.linearRampToValueAtTime(400, start + cycleDur * 0.5);
    osc.frequency.linearRampToValueAtTime(900, start + cycleDur);
    gain.gain.setValueAtTime(0.0001, start);
    gain.gain.exponentialRampToValueAtTime(0.4, start + 0.05);
    gain.gain.exponentialRampToValueAtTime(0.0001, start + cycleDur);
    osc.connect(gain).connect(ctx.destination);
    osc.start(start);
    osc.stop(start + cycleDur + 0.02);
  }
  // Voz "EMERGENCIA NAWARA" al final
  setTimeout(() => {
    try {
      if ('speechSynthesis' in window) {
        const u = new SpeechSynthesisUtterance('¡Emergencia NAWARA!');
        u.lang = 'es-ES';
        u.rate = 1.1;
        u.volume = 1.0;
        u.pitch = 1.2;
        window.speechSynthesis.cancel();
        window.speechSynthesis.speak(u);
      }
    } catch (e) { /* ignore */ }
  }, cycles * cycleDur * 1000);
}

export function showBrowserNotification(title, body) {
  try {
    if (typeof window === 'undefined' || !('Notification' in window)) return;
    if (Notification.permission === 'granted') {
      new Notification(title, { body, tag: 'nawara', renotify: true });
    }
  } catch (e) { /* ignore */ }
}

export function requestNotificationPermission() {
  try {
    if (typeof window === 'undefined' || !('Notification' in window)) return Promise.resolve('unsupported');
    if (Notification.permission === 'default') {
      return Notification.requestPermission();
    }
    return Promise.resolve(Notification.permission);
  } catch (e) {
    return Promise.resolve('error');
  }
}
